<template>
  <div class="tool-list-page">
    <div v-if="showFreeModeBanner" class="free-mode-banner" role="status" aria-live="polite">
      <div class="free-mode-banner__content">
        <i class="el-icon-warning-outline free-mode-banner__icon"></i>
        <span class="free-mode-banner__text">{{ freeModeBannerText }}</span>
      </div>
      <button
        type="button"
        class="free-mode-banner__close"
        aria-label="关闭公告"
        @click="closeFreeModeBanner"
      >
        <i class="el-icon-close"></i>
      </button>
    </div>

    <div class="toollistmain">
      <div v-for="(item,index) in data" :key="index">
          <DBTool :toolname="item.toolname" :detail="item.detail" :address="item.address" :img="item.img" :Charging="item.Charging"></DBTool>
      </div>
    </div>
  </div>
</template>

<script>
    import DBTool from "./DBTool.vue"
    import { toolList } from "@/config/tools.js"
    export default {
    name: 'ToolList',
    components: { DBTool },
    data() {
        return {
            orderid: '',
            tableData: [],
            data: toolList,
            bannerDismissed: false
        }
    },
    computed: {
        coinChargeEnabled() {
            return this.$store.state.coinChargeEnabled !== false
        },
        freeModeBannerText() {
            return '当前全站限时免费，登录后所有工具均可直接使用，不扣金币。'
        },
        showFreeModeBanner() {
            return !this.coinChargeEnabled && !this.bannerDismissed
        }
    },
    methods: {
        closeFreeModeBanner() {
            this.bannerDismissed = true
        }
    }
}
</script>

<style lang="less" scoped>
    .tool-list-page {
        box-sizing: border-box;
    }
    .free-mode-banner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin: 0 0 18px;
        padding: 7px 12px;
        border-radius: 12px;
        border: 1px solid rgba(59, 130, 246, 0.18);
        background:
            linear-gradient(135deg, rgba(239, 246, 255, 0.98) 0%, rgba(224, 242, 254, 0.96) 52%, rgba(219, 234, 254, 0.96) 100%);
        box-shadow: 0 10px 22px rgba(59, 130, 246, 0.08);
    }
    .free-mode-banner__content {
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
        color: #1e3a8a;
    }
    .free-mode-banner__icon {
        flex: 0 0 auto;
        font-size: 16px;
        color: #2563eb;
    }
    .free-mode-banner__text {
        font-size: 13px;
        line-height: 1.25;
        font-weight: 400;
        letter-spacing: 0;
    }
    .free-mode-banner__close {
        flex: 0 0 auto;
        width: 24px;
        height: 24px;
        border: 0;
        border-radius: 999px;
        background: rgba(37, 99, 235, 0.08);
        color: #1e3a8a;
        cursor: pointer;
        transition: background-color 0.16s ease, transform 0.16s ease;
    }
    .free-mode-banner__close:hover {
        background: rgba(37, 99, 235, 0.16);
        transform: translateY(-1px);
    }
    .toollistmain {
        box-sizing: border-box;
    }
    @media(min-width: 769px){
        .toollistmain{
            display: flex;
            flex-wrap: wrap;
        }
    }
    @media(max-width: 768px){
        .toollistmain{
            width: 100%;
            max-width: 100vw;
            margin: 0 auto;
            padding: 8px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .free-mode-banner {
            margin: 0 12px 16px;
            padding: 7px 10px;
            border-radius: 12px;
            align-items: flex-start;
        }
        .free-mode-banner__text {
            font-size: 12px;
        }
        .free-mode-banner__close {
            width: 22px;
            height: 22px;
        }
    }
</style>
